module.exports = __webpack_public_path__ + "static/media/img_feature_photo2@2x.68b73271.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_feature_photo2@2x.webp
// module id = 801
// module chunks = 0